// Main Scripts
// ---------------------
import mainSlideshow from './js/widgets/mainSlideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import masonryCards from './js/widgets/masonryCards.js';
import seoWidget from './js/widgets/seoWidget.js';
import staticSponsors from './js/widgets/staticSponsors.js';
import sponsors from './js/widgets/sponsors.js';
import socialGallery from './js/widgets/socialGallery.js';

// Secondary Scripts
import './js/localjs.js';

if (window.location.pathname === '/') {
  $(document).ready(function () {
    multiScheduleFeature();
    mainSlideshow();
    masonryCards();
    seoWidget();
    staticSponsors();
    sponsors();
    socialGallery();
  });
}
